/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Proxy_TitleInputs */

const en_iconik_proxy_title = /** @type {(inputs: Iconik_Proxy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iconik Proxy Import`)
};

const fr_iconik_proxy_title = /** @type {(inputs: Iconik_Proxy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import du proxy Iconik`)
};

const de_iconik_proxy_title = /** @type {(inputs: Iconik_Proxy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iconik Proxy Import`)
};

const it_iconik_proxy_title = /** @type {(inputs: Iconik_Proxy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione proxy Iconik`)
};

const ru_iconik_proxy_title = /** @type {(inputs: Iconik_Proxy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iconik Proxy Import`)
};

const es_iconik_proxy_title = /** @type {(inputs: Iconik_Proxy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importación de proxy de Iconik`)
};

const zh_cn2_iconik_proxy_title = /** @type {(inputs: Iconik_Proxy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iconik代理导入`)
};

const ja_iconik_proxy_title = /** @type {(inputs: Iconik_Proxy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iconik プロキシインポート`)
};

const hi_iconik_proxy_title = /** @type {(inputs: Iconik_Proxy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आइकॉनिक प्रॉक्सी आयात`)
};

const pt_pt2_iconik_proxy_title = /** @type {(inputs: Iconik_Proxy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importação de proxy Iconik`)
};

/**
* | output |
* | --- |
* | "Iconik Proxy Import" |
*
* @param {Iconik_Proxy_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_proxy_title = /** @type {((inputs?: Iconik_Proxy_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Proxy_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_proxy_title(inputs)
	if (locale === "de") return de_iconik_proxy_title(inputs)
	if (locale === "it") return it_iconik_proxy_title(inputs)
	if (locale === "ru") return ru_iconik_proxy_title(inputs)
	if (locale === "es") return es_iconik_proxy_title(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_proxy_title(inputs)
	if (locale === "ja") return ja_iconik_proxy_title(inputs)
	if (locale === "hi") return hi_iconik_proxy_title(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_proxy_title(inputs)
	return en_iconik_proxy_title(inputs)
});